import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { OutreachReplyLabel } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
import { labelTone, REPLY_LABEL_TEXT } from './replyLabels';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

const TONE_CLASS = { vio: shared.chipVio, pos: shared.chipPos, warn: shared.chipWarn, muted: shared.chipMuted };

/** The AI label of a reply as a chip (design outreach g1). A person can change it in the thread. */
const ReplyLabelChipComponent: React.FC<{ label: OutreachReplyLabel }> = ({ label }) => {
  const intl = useIntl();
  return (
    <span className={clsx(shared.chip, TONE_CLASS[labelTone(label)])} data-testid={`reply-label-${label}`}>
      {intl.formatMessage(REPLY_LABEL_TEXT[label] ?? REPLY_LABEL_TEXT.other)}
    </span>
  );
};

export const ReplyLabelChip = TypedMemo(ReplyLabelChipComponent);
